<template>
  <NavbarOne />
  <PageBanner
    pageTitle="الأسئلة الشائعة"
    subTitle="اعثر على إجابات لأكثر الأسئلة شيوعًا حول اشتراكات IPTV، الأجهزة المدعومة، طرق التفعيل، جودة البث، والدعم الفني."
    :pageBannerImage="pageBannerImg"
  />
  <FAQ />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import FAQ from "@/components/FAQ/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "FAQPage",
  components: {
    NavbarOne,
    PageBanner,
    FAQ,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "الأسئلة الشائعة | إجابات حول اشتراكات IPTV",
      meta: [
        {
          name: "description",
          content:
            "اطلع على إجابات أكثر الأسئلة شيوعًا حول اشتراكات IPTV، التفعيل، الأجهزة المدعومة، القنوات، جودة البث، وطرق حل المشكلات لضمان أفضل تجربة مشاهدة.",
        },
        {
          name: "keywords",
          content:
            "الأسئلة الشائعة IPTV, FAQ IPTV, اشتراك IPTV, تفعيل IPTV, دعم IPTV, أجهزة IPTV, قنوات عربية, بث مباشر",
        },
        {
          property: "og:title",
          content: "الأسئلة الشائعة | إجابات حول اشتراكات IPTV",
        },
        {
          property: "og:description",
          content:
            "كل ما تحتاج معرفته عن اشتراكات IPTV، التفعيل، الأجهزة المدعومة، وجودة البث في مكان واحد.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/faq",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-5.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>